import { z } from 'zod';

// The wire shape is snake_case; the ApiClient converts it to camelCase before this runs.

// Rendered verbatim as text. The backend will grow this to name the masked email; nothing here
// parses it, so that needs no FE change.
export const sendOtpResponseSchema = z.object({
  message: z.string(),
});

export const verifyOtpResponseSchema = z.object({
  token: z.string(),
  // `offset` is load-bearing: Date.parse reads a naive datetime as LOCAL time, so it would land
  // 5h30m early on an IST client — a 30-minute session against the 6h TTL. Fail loudly instead.
  expiresAt: z.string().datetime({ offset: true }),
});
